/**
 * @generated SignedSource<<db24d03892b4eb84461db3d7b4e3b5b9>>
 * @relayHash 0487c8ed319042e967303b02df0519f3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9b27b842751d29460eadb80e03954e0925aaa3034a2864705bf9a945859c7c0c

import type { ConcreteRequest } from 'relay-runtime';
export type useCurrentPageTemplateDataTwcEligibilityQuery$variables = {
  cloudIds: ReadonlyArray<string>;
};
export type useCurrentPageTemplateDataTwcEligibilityQuery$data = {
  readonly tenantContexts: ReadonlyArray<{
    readonly cloudId: string | null;
    readonly confluenceEntitlementInfo: {
      readonly entitlement?: {
        readonly enterpriseRelationships: ReadonlyArray<{
          readonly relationshipType: string | null;
        } | null> | null;
        readonly relatesFromEntitlements: ReadonlyArray<{
          readonly relationshipType: string | null;
        } | null> | null;
      } | null;
    } | null;
  } | null> | null;
};
export type useCurrentPageTemplateDataTwcEligibilityQuery = {
  response: useCurrentPageTemplateDataTwcEligibilityQuery$data;
  variables: useCurrentPageTemplateDataTwcEligibilityQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudIds"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudIds",
    "variableName": "cloudIds"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "cloudId"
},
v3 = [
  {
    "kind": "Literal",
    "name": "hamsProductKey",
    "value": "confluence.ondemand"
  }
],
v4 = [
  {
    "kind": "ScalarField",
    "name": "relationshipType"
  }
],
v5 = {
  "args": [
    {
      "kind": "Literal",
      "name": "relationshipTypes",
      "value": "COLLECTION"
    }
  ],
  "concreteType": "CcpEntitlementRelationship",
  "kind": "LinkedField",
  "name": "relatesFromEntitlements",
  "plural": true,
  "selections": (v4/*: any*/),
  "storageKey": "relatesFromEntitlements(relationshipTypes:\"COLLECTION\")"
},
v6 = {
  "alias": "enterpriseRelationships",
  "args": [
    {
      "kind": "Literal",
      "name": "relationshipTypes",
      "value": "ENTERPRISE"
    }
  ],
  "concreteType": "CcpEntitlementRelationship",
  "kind": "LinkedField",
  "name": "relatesFromEntitlements",
  "plural": true,
  "selections": (v4/*: any*/),
  "storageKey": "relatesFromEntitlements(relationshipTypes:\"ENTERPRISE\")"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useCurrentPageTemplateDataTwcEligibilityQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          {
            "alias": "confluenceEntitlementInfo",
            "args": (v3/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "CcpEntitlement",
                    "kind": "LinkedField",
                    "name": "entitlement",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/)
                    ]
                  }
                ],
                "type": "CommerceEntitlementInfoCcp"
              }
            ],
            "storageKey": "entitlementInfo(hamsProductKey:\"confluence.ondemand\")"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCurrentPageTemplateDataTwcEligibilityQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          {
            "alias": "confluenceEntitlementInfo",
            "args": (v3/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "CcpEntitlement",
                    "kind": "LinkedField",
                    "name": "entitlement",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      }
                    ]
                  }
                ],
                "type": "CommerceEntitlementInfoCcp"
              }
            ],
            "storageKey": "entitlementInfo(hamsProductKey:\"confluence.ondemand\")"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "0487c8ed319042e967303b02df0519f3",
    "id": "9b27b842751d29460eadb80e03954e0925aaa3034a2864705bf9a945859c7c0c",
    "metadata": {},
    "name": "useCurrentPageTemplateDataTwcEligibilityQuery",
    "operationKind": "query",
    "text": "query useCurrentPageTemplateDataTwcEligibilityQuery($cloudIds:[ID!]!){tenantContexts(cloudIds:$cloudIds){cloudId,confluenceEntitlementInfo:entitlementInfo(hamsProductKey:\"confluence.ondemand\"){__typename,...on CommerceEntitlementInfoCcp{entitlement{relatesFromEntitlements(relationshipTypes:\"COLLECTION\"){relationshipType},enterpriseRelationships:relatesFromEntitlements(relationshipTypes:\"ENTERPRISE\"){relationshipType},id}}}}}"
  }
};
})();

(node as any).hash = "6ad66e5687eb8286add54df09b0e2383";

export default node;
